import { returnPayload } from '@ardoq/common-helpers';
import {
  actionCreator,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import { ALL_LANGUAGE_CODES } from '../supportedLanguages';

const SESSION_STORAGE_KEY = 'I18N_LANGUAGE_OVERRIDE';

export type LanguageOverride = string | null;

export const toLanguageOverride = (value: unknown): LanguageOverride =>
  typeof value === 'string' && ALL_LANGUAGE_CODES.includes(value)
    ? value
    : null;

const loadLanguageOverride = (): LanguageOverride => {
  try {
    return toLanguageOverride(sessionStorage.getItem(SESSION_STORAGE_KEY));
  } catch {
    return null;
  }
};

export const saveLanguageOverride = (override: LanguageOverride): void => {
  try {
    if (override === null) {
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(SESSION_STORAGE_KEY, override);
  } catch {
    // Ignore storage errors
  }
};

export const languageOverrideChanged = actionCreator<LanguageOverride>(
  '[i18n] language override changed'
);

export const languageOverride$ = persistentReducedStream<LanguageOverride>(
  'languageOverride$',
  loadLanguageOverride(),
  [reducer(languageOverrideChanged, returnPayload)]
);
